import { ExportDestination } from "./types";

export const exportDestinationStepTitles = {
  [ExportDestination.CSVDownload]: [],
  [ExportDestination.AdLibrary]: ["Match Columns", "Fill Ad Info"],
  [ExportDestination.GoogleSpreadsheet]: ["Map Data"],
  [ExportDestination.Portal]: ["Add Fields"],
};
